import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import PendingRequest from "./PendingRequest";
import AcceptedRequest from "./AcceptedRequest";
import DeclinedRequest from "./DeclinedRequest";
import Reason from "./Reason";
import { getMonetizationStatsData } from "../../store/monetization/monetization.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconFileDescription,
  IconCalendarEvent,
  IconCircleCheck,
  IconCalendarCheck,
  IconClockHour4,
  IconCalendarTime,
  IconCircleX,
  IconCalendarX,
} from "@tabler/icons-react";

const ManageMonetization = () => {
  const dispatch = useDispatch();
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { monetizationStatsData } = useSelector((state) => state.monetization);

  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("User");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getMonetizationStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Request",
      count: monetizationStatsData?.totalRequest,
      Icon: IconFileDescription,
    },
    {
      title: "Total Accepted",
      count: monetizationStatsData?.totalAccepted,
      Icon: IconCircleCheck,
    },
    {
      title: "Total Pending",
      count: monetizationStatsData?.totalPending,
      Icon: IconClockHour4,
    },
    {
      title: "Total Rejected",
      count: monetizationStatsData?.totalRejected,
      Icon: IconCircleX,
    },
    {
      title: "Total Received Today",
      count: monetizationStatsData?.totalRequestReceivedToday,
      Icon: IconCalendarEvent,
    },
    
    {
      title: "Total Accepted Today",
      count: monetizationStatsData?.totalAcceptedToday,
      Icon: IconCalendarCheck,
    },
   
    {
      title: "Total Pending Today",
      count: monetizationStatsData?.totalPendingToday,
      Icon: IconCalendarTime,
    },
   
    {
      title: "Total Rejected Today",
      count: monetizationStatsData?.totalRejectedToday,
      Icon: IconCalendarX,
    },
  ];

  return (
    <div className="userPage">
      <div className="dashboardHeader primeHeader mb-3 p-0">
        <NewTitle
          dayAnalyticsShow={true}
          setEndDate={setEndDate}
          setStartDate={setStartDate}
          startDate={startDate}
          endDate={endDate}
          setMultiButtonSelect={handleMultiButtonSelect}
          multiButtonSelect={multiButtonSelect}
          labelData={["Pending", "Accepted", "Declined"]}
        />
      </div>
      <StatsCards cards={statsCards} />

      {multiButtonSelect == "Pending" && (
        <PendingRequest
          endDate={endDateData}
          startDate={startDateData}
          multiButtonSelectNavigate={setMultiButtonSelect}
        />
      )}
      {multiButtonSelect == "Accepted" && (
        <AcceptedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {multiButtonSelect == "Declined" && (
        <DeclinedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {dialogueType === "monetization" && <Reason />}
    </div>
  );
};

export default ManageMonetization;
